import { render, staticRenderFns } from "./DetalharOrganogramaView.vue?vue&type=template&id=2d07789a"
import script from "./DetalharOrganogramaView.vue?vue&type=script&lang=js"
export * from "./DetalharOrganogramaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports